<template>

  <master-layout :has-navigation-menu="false" sun="tr-to-bl" :indent-x="step === 0">

    <!--  back button -->
    <template #prepend>
      <div class="w-full">
        <div v-if="step === 0"
             @click="$router.go(-1)"
             class=" w-[52px] h-[52px] z-20   top-[22px] left-[22px] bg-primary-0  flex items-center justify-center ">
          <font-awesome-icon :icon="['fas','angle-left']" class="text-white text-4xl"/>
        </div>
      </div>
    </template>

    <div class="flex flex-col justify-between max-h-full h-full  " style="">

      <div
          class="flex-1 h-full max-h-full flex flex-col relative"
          :class="isWeb && step === 0 ? 'min-h-0 overflow-y-auto' : 'overflow-y-hidden'"
      >

        <div :class="{'px-4':step !== 0}">
          <!--                    v-if="step === 0"-->

          <img :src="`${IMG_URL}/${selectedMeal?.images[1] ?? selectedMeal?.images[0]}`" class="w-full mt-12 h-auto"/>
          <!--          <img src="/images/b2.png" class="w-full mt-12 h-auto"/>-->

          <div class="text-white mt-8 flex items-center font-bold text-4xl">
            <span class="mr-4 italic"> {{ selectedMealTitle.title }}</span>
            <span v-if="selectedMealTitle.title.length <16" :data-title="selectedMealTitle.endWord"
                  class="burger-highlight h-[45px] relative"></span>
          </div>

          <div v-if="selectedMealTitle.title.length >=16"
               class="text-white mt-2 pl-2 mb-3 flex items-center font-bold text-4xl">
            <span :data-title="selectedMealTitle.endWord" class="burger-highlight h-[45px] relative"></span>
          </div>

          <hr class="opacity-10 mt-4 border-white">

        </div>

        <transition name="scale" mode="out-in">
          <div v-if="step === 0" key="step-0">

            <div class="text-white mt-4  font-light">
              <span class=" font-medium"> {{ $t('meal_content') }} </span>
              <span class="opacity-75">{{ translateVal('text', selectedMeal) }}</span>
              <!--              <span class="opacity-75">{{ selectedMeal.text }}</span>-->
            </div>

            <div class="text-white  mt-1 font-light">
              <span class=" font-medium">{{ $t('weight') }}  </span>
              <span class="opacity-75">{{ selectedMeal.weight }}</span>
            </div>

            <div class="text-white  mt-1 font-light">
              <span class=" font-medium">{{ $t('allergens') }} </span>
              <span class="opacity-75">{{ selectedMeal.allergens }}</span>
            </div>

          </div>

          <template v-else>

            <div v-if="!hasFlyParts" class="w-full px-4 mt-7 shrink grow flex flex-col  overflow-y-scroll">
              <div v-for="(part,i) in parts" class="flex mb-3  items-center  justify-between">
                <div class="text-white capitalize  ">
                  {{ part.text }}
                </div>
                <MyCheckBox v-model="parts[i].checked"/>
              </div>
            </div>

            <div v-else ref="burgerPartsContainer" class="w-full flex flex-col h-full overflow-y-hidden relative">
              <template v-if="!lo">


                <div v-for="(layer, index) in reversedLayers"
                     :key="layer.src"
                     class="w-full h-auto  absolute top-0   animate-fall flex"
                     :style="{
                     'z-index': index + 1,
                  animationDelay: (index *0.1) + 's',
    '--final-position': layer.offsetY + 'px'
                   }"
                >

                  <img
                      :src="layer.src"
                      :style="{
    width: maxLayerPartWidth + 'px',
    opacity: layers[layer.originalIndex].active ? 1 : 0.25,
  }"
                      class="ml-[12px]"
                      :class="{'floating-1':adone}"
                  />

                  <div class="flex-1 flex pr-4 items-center justify-end delayed-fade-in"
                       :style="{'animation-delay': `${1 + (((layers.length + 1 ) - index )* 0.1)}s`}">
                    <div class="flex space-x-2  items-center  justify-between">
                      <div class="text-white text-lg capitalize   ">
                        {{ layer.title }}
                      </div>
                      <MyCheckBox :disabled="!layer.canRemove" v-model="layers[layer.originalIndex].active"/>
                    </div>
                  </div>
                </div>


              </template>
              <img src="/b/t.png" class="absolute w-full h-auto bottom-[-5%] left-[-33%]">
            </div>

          </template>

        </Transition>

      </div>

      <div class="shrink-0" :class="{'px-4':step !== 0}">
        <hr class="border-white opacity-10 mb-4">
        <div class="flex pb-4  items-center justify-between">

          <div v-if="step === 0" class="">
            <div class="text-white text-xs opacity-85">
              {{ $t('price') }}
            </div>
            <div class="text-secondary-0 font-bold text-3xl">
              {{ price }} €
            </div>
          </div>

          <BackButton v-else @click="step = 0"/>

          <FloatButton v-if="step === 0" @click="step = 1" :icon="['fal','angle-right']">
            <span class="mr-12">
               {{ $t('next') }}
            </span>
          </FloatButton>

          <FloatButton v-else @click="openMealSideDish" :icon="['fal','basket-shopping']">
            <span class="mr-12">
               {{ $t('add_to_cart') }}
            </span>
          </FloatButton>

        </div>
      </div>

    </div>

  </master-layout>

</template>

<script setup>
import {computed, ref, watch} from 'vue'
import {useRoute, useRouter} from "vue-router";
import {ROUTE_NAMES} from "@/router";
import MasterLayout from "@/layouts/MasterLayout.vue";
import useLayoutStore from "@/stores/layoutStoreStore";
import useContentStore from "@/stores/contentStore";
import {IMG_URL} from "@/content/lists";
import useCartStore from "@/stores/cartStore";
import FloatButton from "@/components/buttons/FloatButton.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import {i18n, translateVal} from "@/plugins/l18m";
import MyCheckBox from "@/components/MyCheckBox.vue";
import {platform} from "@/plugins/capacitor/SafeArea";

const step = ref(0)
const isWeb = platform === 'web'

const layoutStore = useLayoutStore()
const contentStore = useContentStore()

const stepTransition = computed(() => {
  return step.value === 0 ? 'slide-right' : 'slide-left';
})

const router = useRouter()
const route = useRoute()

const selectedMealIndex = Number(route.query.index)

const selectedMeal = computed(() => {
  return contentStore.itemsInCategory[selectedMealIndex]
})

const price = computed(() => Number(selectedMeal.value?.pluItem?.pluPrice ?? 0).toFixed(2))

const selectedMealTitle = computed(() => {
  const t = translateVal('title', selectedMeal.value)
  const text = t.replace(/\s+$/, '') ?? '';
  // const text = selectedMeal.value.title.replace(/\s+$/, '') ?? '';
  const split = text.split(' ')
  const title = split.slice(0, split.length - 1).join(' ')
  const endWord = split[split.length - 1] ?? '-'
  return {
    title,
    endWord
  }
})

const parts = ref([])

watch(selectedMeal, () => {
  // parts.value = (selectedMeal.value.text ?? '').split(',').map(item => ({
  parts.value = (translateVal('text', selectedMeal.value) ?? '').split(',').map(item => ({
    text: item,
    checked: true
  }))
}, {immediate: true, deep: true})


const cartStore = useCartStore()

// precache images
watch(() => step.value, (value) => {
  if (value === 1) {
    const mealExtraGroups = contentStore.selectedMealExtraGroups ?? []
    console.log('mealExtraGroups', mealExtraGroups)
    mealExtraGroups.forEach(group => {
      const products = group?.products ?? []
      products.forEach(item => {
        if (item?.product?.images[0]) {
          const img = new Image()
          img.src = `${IMG_URL}/${item.product.images[0]}`
        }
      })
    })
  }
})

const openMealSideDish = () => {

  let removed = ''
  if (hasFlyParts.value) {
    const removedLayers = layers.value.filter(item => item.active === false).map(item => item.title_sk).join(', ')
    removed = removedLayers
  } else {
    removed = parts.value.filter(item => item.checked === false).map(item => item.text).join(', ')
  }

  const {index: addedOnIndexCartStore} = cartStore.addProductToCart({
    product: {...selectedMeal.value},
    removeFromMeal: removed,
    extra: {}
  })

  router.push({
    name: ROUTE_NAMES.MEAL_SIDE_DISH,
    query: {
      cartItemIndex: addedOnIndexCartStore,
    }
  })

}

console.log('selectedMeal ===>', selectedMeal.value)
const hasFlyParts = computed(() => selectedMeal.value?.parts && selectedMeal.value?.parts.length > 0)

console.log('hasFlyParts', hasFlyParts.value)


const mapLayers = () => {
  console.log('mapLayers()')
  if (!hasFlyParts.value) return []
  let map = []

  const textKey = 'name_' + i18n.global.locale.value
  for (let partId of selectedMeal.value?.parts ?? []) {
    const item = contentStore.burgerFlyParts[partId]
    if (!item) continue
    map.push({
      src: '/images/burger-parts/' + item.src,
      title: item[textKey],
      title_sk: item.name_sk,
      title_en: item.name_en,
      title_cz: item.name_cz,
      title_de: item.name_de,
      canRemove: true,
      active: true
    })
  }
  // return [...map.reverse()]
  return map
}

const layers = ref(mapLayers())

const reversedLayers = computed(() => {
  return layers.value.map((layer, idx) => ({
    ...layer,
    originalIndex: idx
  })).reverse();
});


console.log('layers', layers.value)

// const layers = ref([
//   {
//     src: `/b/zemla-vrch-min.png`,
//     title: 'Vrch žemle',
//     canRemove: false
//   },
//   {
//     src: `/b/salat-min.png`,
//     title: "Šalát",
//     canRemove: true
//   },
//   {
//     src: `/b/rajciny-min.png`,
//     title: "Rajčina",
//     canRemove: true
//   },
//   {
//     src: `/b/slanina-min.png`,
//     title: "Slanina",
//     canRemove: true
//   },
//   {
//     src: `/b/cheddar-min.png`,
//     title: "Sýr",
//     canRemove: true
//   },
//   {
//     src: `/b/meso-min.png`,
//     title: "Mäso",
//     canRemove: true
//   },
//   {
//     src: `/b/cibula-min.png`,
//     title: "Cibula",
//     canRemove: true
//   },
//   {
//     src: `/b/aioli-min.png`,
//     title: "Omáčka",
//     canRemove: true
//   },
//   {
//     src: `/b/zemla-spodok-min.png`,
//     title: 'Spodok žemle',
//     canRemove: false
//   },
// ].map(i => ({
//   ...i,
//   active: true
// })))


const burgerPartsContainer = ref(null)
const maxLayerPartWidth = ref(0)
const partHeight = ref(0)
const lo = ref(true)
const adone = ref(false)

watch(() => burgerPartsContainer.value, async (v) => {
  if (!v) return;

  lo.value = true
  // Získanie výšky kontajnera
  const safeSize = 14 //px
  const containerHeight = v.clientHeight - safeSize;
  partHeight.value = containerHeight / layers.value.length;

  // Načítanie rozmerov všetkých obrázkov
  const sizes = await Promise.all(
      [...layers.value].map(layer => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = layer.src;
          img.onload = () => {
            resolve({
              src: layer.src,
              width: img.width,
              height: img.height
            });
          };
          img.onerror = e => {
            console.log('Error loading image', e)
          }
        });
      })
  );

  // Funkcia na výpočet maximálnej možnej šírky
  const calculateMaxWidth = () => {
    // Skúšame postupne rôzne šírky tak, aby celková výška sedela
    let maxPossibleWidth = Infinity;

    // Iterujeme cez veľkosti, aby sme našli optimálnu šírku
    for (let width = 1; width <= Math.max(...sizes.map(s => s.width)); width++) {
      const scaledHeights = sizes.map(size => (width / size.width) * size.height);
      const totalHeight = scaledHeights.reduce((sum, h) => sum + h, 0);

      // Ak celková výška je menšia ako kontajner, nájdeme limit šírky
      if (totalHeight <= containerHeight) {
        maxPossibleWidth = width;
      } else {
        break;
      }
    }

    return maxPossibleWidth;
  };

  // Získanie maximálnej šírky
  maxLayerPartWidth.value = calculateMaxWidth();


  sizes.forEach(size => {
    let newHeight = (maxLayerPartWidth.value / size.width) * size.height

    // newHeight = newHeight + (newHeight / 100) * 25
    // size.newHeight = (maxLayerPartWidth.value / size.width) * size.height;
    size.newHeight = newHeight;
  });

  let totalSoFar = 7;
  // const minusOffset = 12
  sizes.forEach(size => {
    for (let i = 0; i < layers.value.length; i++) {
      if (layers.value[i].src === size.src) {
        layers.value[i].newHeight = size.newHeight;

        layers.value[i].offsetY = totalSoFar;
        totalSoFar += size.newHeight
        // totalSoFar -= (size.newHeight / 100) * 25
      }
    }
  })

  // each part height is smaller by 25% after transform, so we extend maxLayerPartWidth to fit all parts
  // maxLayerPartWidth.value += 100
  // maxLayerPartWidth.value += (maxLayerPartWidth.value / 100) * 25


  setTimeout(() => {
    lo.value = false
    adone.value = true
  }, 1 + (sizes.length * 0.1))

  console.log('Max Layer Part Width:', maxLayerPartWidth.value);
});


</script>

<style scoped lang="scss">

.burger-highlight::before {
  content: attr(data-title);
  position: absolute;
  top: 0;
  left: 0;
  //height: 100%;
  background-color: #fbb665;
  transform: skew(-10deg);
  color: #232227;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
  //padding-left: 4px;
  padding: 1px 8px;
  //padding-top: 4px;
  //padding-bottom: 4px;
  z-index: 10;
}

/* Prechod z prava do ľava */
.slide-right-enter-active, .slide-right-leave-active {
  transition: transform 0.2s ease;
}

.slide-right-enter-from {
  transform: translateX(100%);
}

.slide-right-leave-to {
  transform: translateX(-100%);
}

.slide-right-enter-to, .slide-right-leave-from {
  transform: translateX(0%);
}

/* Prechod z ľava do prava */
.slide-left-enter-active, .slide-left-leave-active {
  transition: transform 0.2s ease;
}

.slide-left-enter-from {
  transform: translateX(-100%);
}

.slide-left-leave-to {
  transform: translateX(100%);
}

.slide-left-enter-to, .slide-left-leave-from {
  transform: translateX(0%);
}

.aa::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px; /* Výška prechodu */
  background: linear-gradient(transparent, black);
  opacity: 0.1;
}
</style>
